import React from 'react';

import {
  faFileInvoiceDollar,
  faUsers,
  faMoneyBill,
  faCalculator,
  faPieChart,
  faBusinessTime,
} from '~components/icon';
import StatisticStack from '~components/visualisation/statistic/Statistics';

import { formatCompactCurrency } from '~libs/formatters';

import { DashboardBudgetsSummary } from '~support-at-home/models/dashboard';

/** Statistic icon colours aligned with the project SCSS theme variables */
const ICON_COLOURS = {
  primary: '#00b4ae',
  secondary: '#1e384c',
  green: '#008000',
  warning: '#faa51a',
  onHold: '#7b90d6',
  red: '#ff0000',
} as const;

interface ComponentProps {
  summary: DashboardBudgetsSummary;
}

export const DashboardSummary: React.FC<ComponentProps> = ({ summary }) => {
  const statistics = [
    {
      title: 'Total Included Budgets',
      type: 'value' as const,
      value: summary.total_included_budgets,
      icon: faFileInvoiceDollar,
      iconColor: ICON_COLOURS.primary,
    },
    {
      title: 'Total Unique Clients',
      type: 'value' as const,
      value: summary.total_unique_clients,
      icon: faUsers,
      iconColor: ICON_COLOURS.secondary,
    },
    {
      title: 'Total Available Budget',
      type: 'value' as const,
      value: formatCompactCurrency(summary.total_available_budget),
      icon: faMoneyBill,
      iconColor: ICON_COLOURS.green,
    },
    {
      title: 'Total Allocated Budget',
      type: 'value' as const,
      value: formatCompactCurrency(summary.total_allocated_budget),
      icon: faCalculator,
      iconColor: ICON_COLOURS.warning,
    },
    {
      title: 'Avg Allocation Rate',
      type: 'value' as const,
      value: `${(summary.average_allocation_rate * 100).toFixed(1)}%`,
      icon: faPieChart,
      iconColor: ICON_COLOURS.onHold,
    },
    {
      title: 'Avg Utilisation Rate',
      type: 'value' as const,
      value: `${(summary.average_utilisation_rate * 100).toFixed(1)}%`,
      icon: faBusinessTime,
      iconColor: ICON_COLOURS.red,
    },
  ];

  return (
    <StatisticStack statistics={statistics} />
  );
};
